import {
  getAttr,
  querySupplierScanRecordInfo,
  querySupplierScanRecord,
  supplierScanRecordQuery,
  queryScanException,
  queryStoreScanRecord,
  updateStoreRecordStatus,
  scanExceptionUpdateStatus,
  querySupplierInventory,
  exportSupplierScanRecord,
  exportSupplierInventory,
  exportScanException,
  exportSupplierScanRecordDetail,
  querySupplierScanRecordDetail,
  queryCustomerLevelList,
  queryCustomerLevelBaseStorePage,
  getCustomerLevelDetail,
  exportCustomerLevelStore,
  deleteCustomerLevel,
  importCustomerLevelStoreFile,
  editCustomerLevel,
  querySupplierCount,
  exportSupplierCount,
  getPCRAttr,
  queryLastFiveYearsWithMerge,
  getOrgSupplierCountQuantity
} from "@/graphql/scan.gql";
import { easyMutate, resRest } from "@root/lib/utils";
import Vue from "vue";
import { httpServer as http } from "@/lib/axios";

export default {
  namespaced: true,
  state: {
    // 出库类型 -- 数组
    outTypeList: [
      {
        label: "无质保卡出库",
        value: "0"
      },
      {
        label: "质保卡出库",
        value: "1"
      },
      {
        label: "批发出库",
        value: "3"
      }
    ],
    // 市场类型 -- 数组
    marketList: [
      {
        label: "乘用",
        value: "PCR"
      },
      {
        label: "商用",
        value: "TBR"
      }
    ],
    // 出入库状态列表
    inOutStatusList: [
      // {
      //   label: "异常审核",
      //   value: "0"
      // },
      {
        label: "已生效",
        value: "1"
      },
      // {
      //   label: "已退回",
      //   value: "2"
      // },
      {
        label: "已失效",
        value: "3"
      },
      {
        label: "待确认",
        value: "4"
      }
    ],
    // 扫码类型 -- 数组
    scanTypeList: [
      {
        value: "1",
        label: "手工输入"
      },
      {
        value: "0",
        label: "扫码识别"
      }
    ],
    // 扫码异常类型 -- 数组
    // 审核状态 -- 数组
    examineStatusList: [
      {
        value: 0,
        label: "待审核"
      },
      {
        value: 1,
        label: "已审核"
      }
    ],
    // 审核结果
    detailStatusObj: {
      1: "已通过",
      2: "已拒绝"
    },
    isK1Obj: {
      0: "非正规渠道",
      1: "正规渠道"
    },
    // 有效入库
    takeEffectObj: {
      0: "否",
      1: "是"
      // 0: "待确认",
      // 1: "有效",
      // 2: "已退回",
      // 3: "无效",
      // 4: "待确认"
    },
    storeAreaObj: {
      0: "超出门店范围",
      1: "门店范围内",
      2: "其他"
    }
    // systemTypeObj: {
    //   1: "App",
    //   2: "微信",
    //   3: "k1扫码枪",
    //   4: "系统后台"
    // }
  },
  getters: {
    // 出库类型 -- 对象
    outTypeListObj(state) {
      let result = {};
      state.outTypeList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 市场类型 -- 对象
    marketListObj(state) {
      let result = {};
      state.marketList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 出入库状态 -- 对象
    inOutStatusListObj(state) {
      let result = {};
      state.inOutStatusList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 扫码类型 -- 对象
    scanTypeListObj(state) {
      let result = {};
      state.scanTypeList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 扫码异常类型 -- 对象
    // 审核状态 -- 对象
    examineStatusObj(state) {
      let result = {};
      state.examineStatusList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    }
  },
  actions: {
    async queryInoutInventory({ state, dispatch }, params) {
      const statusList = await dispatch(
        "common/queryDataDictionaryListLang",
        { statePath: "inoutInventoryList", ddCode: "INOUT_INVENTORY_STATUS" },
        {
          root: true
        }
      );
      // update state
      state.inOutStatusList = statusList;
    },
    // TODO: 重构
    // K1扫码异常申诉修改状态
    async scanExceptionUpdateStatus(
      { commit, state, rootState }: any,
      data?: any
    ) {
      await rootState.gql.mutate({
        mutation: scanExceptionUpdateStatus,
        variables: data
      });
    },
    async getAttr({ commit, state, rootState }: any, data?: any) {
      const {
        data: { api }
      } = await rootState.gql.query({
        query: getAttr,
        variables: data
      });
      // 扁平率 _flatten
      // 花纹 _pattern
      // 轮毂直径 _hubDiameter
      // 断面宽 _sectionWidth
      const attrCodes = api.map(({ attrCode, dataList }) => ({
        label: attrCode && attrCode.replace(/[^0-9A-Za-z]+/g, ""),
        value: dataList
      }));
      attrCodes.forEach(({ label, value }) => {
        commit("easyMutate", { path: `${label}List`, data: value });
      });
      return attrCodes || {};
    },
    // 库存流水详情
    async querySupplierScanRecordInfo(
      { commit, state, rootState }: any,
      variables?: any
    ) {
      const { data } = await rootState.gql.query({
        query: querySupplierScanRecordInfo,
        variables: variables
      });
      const result = {
        list: resRest(data) || [],
        total: data.api.pageInfo.totalCount || 0
      };
      commit("easyMutate", { path: `dataList`, data: result.list });
      return result;
    },
    // 库存流水
    async supplierScanRecordQuery(
      { commit, state, rootState }: any,
      variables?: any
    ) {
      const { data } = await rootState.gql.query({
        query: supplierScanRecordQuery,
        variables: variables
      });
      const list = resRest(data);
      const resDatalist = list.map((rootItem, rootIndex) => {
        let { list, ...other } = rootItem;
        let children = [];
        if (list && list.length > 0) {
          // count 数目一定是要内层count累加
          let childTotalCount = 0;
          list.forEach((item, nodeIndex) => {
            let { list, updateUser, updateTime, count, ...others } = item;
            if (list && list.length > 0) {
              childTotalCount = childTotalCount + count;
              list.forEach((el, node2Index) => {
                children.push({
                  updateUser,
                  updateTime,
                  ...el,
                  ...others,
                  __index__: `${rootIndex}_${nodeIndex}_${node2Index}_key`
                });
              });
            }
          });
          rootItem["count"] = childTotalCount;
        }
        return {
          __index__: `${rootIndex}_key`,
          children,
          ...rootItem
        };
      });
      const result = {
        list: resDatalist || [],
        total: data.api.pageInfo.totalCount || 0
      };
      return result;
    },
    async querySupplierScanRecordDetail(
      { commit, state, rootState }: any,
      variables?: any
    ) {
      const { data } = await rootState.gql.query({
        query: querySupplierScanRecordDetail,
        variables: variables
      });
      const list = resRest(data);
      const resDatalist = list.map((rootItem, rootIndex) => {
        let { list, ...other } = rootItem;
        let children = [];
        if (list && list.length > 0) {
          // count 数目一定是要内层count累加
          let childTotalCount = 0;
          list.forEach((item, nodeIndex) => {
            let { list, updateUser, updateTime, count, ...others } = item;
            if (list && list.length > 0) {
              childTotalCount = childTotalCount + count;
              list.forEach((el, node2Index) => {
                children.push({
                  updateUser,
                  updateTime,
                  ...el,
                  ...others,
                  __index__: `${rootIndex}_${nodeIndex}_${node2Index}_key`
                });
              });
            }
          });
          rootItem["count"] = childTotalCount;
        }
        return {
          __index__: `${rootIndex}_key`,
          children,
          ...rootItem
        };
      });
      const result = {
        list: resDatalist || [],
        total: data.api.pageInfo.totalCount || 0
      };
      return result;
    },
    async queryScanException({ rootState }, params) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryScanException,
        variables: params
      });

      return { list: resRest(data), total };
    },
    async queryCustomerLevelList({ rootState }, params) {
      let { data } = await rootState.gql.query({
        query: queryCustomerLevelList,
        variables: params
      });
      const list = data.api || [];
      return list;
    },
    async getCustomerLevelDetail({ rootState }, params) {
      let { data } = await rootState.gql.query({
        query: getCustomerLevelDetail,
        variables: params
      });
      return data.api || {};
    },
    async queryCustomerLevelBaseStorePage({ rootState }, params) {
      let { data } = await rootState.gql.query({
        query: queryCustomerLevelBaseStorePage,
        variables: params
      });
      const list = data.api || [];
      return list;
    },
    async importCustomerLevelStoreFile({ rootState }, params) {
      let { data } = await rootState.gql.query({
        query: importCustomerLevelStoreFile,
        variables: params
      });
      const list = data.api || [];
      return list;
    },
    async exportScanException({ rootState }, params) {
      let res = await rootState.gql.query({
        query: exportScanException,
        variables: params
      });
    },
    async exportSupplierScanRecord({ rootState }, params) {
      let res = await rootState.gql.query({
        query: exportSupplierScanRecord,
        variables: params
      });
    },
    async exportCustomerLevelStore({ rootState }, params) {
      let res = await rootState.gql.query({
        query: exportCustomerLevelStore,
        variables: params
      });
    },
    async exportSupplierScanRecordDetail({ rootState }, params) {
      let res = await rootState.gql.query({
        query: exportSupplierScanRecordDetail,
        variables: params
      });
    },
    async exportSupplierInventory({ rootState }, params) {
      let res = await rootState.gql.query({
        query: exportSupplierInventory,
        variables: params
      });
    },
    async queryStoreScanRecord({ rootState }, params) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryStoreScanRecord,
        variables: params
      });
      const list = resRest(data);
      const res = list.map((rootItem, outIndex) => {
        // 添加索引，嵌套表格用
        rootItem.__index__ = outIndex + "_key";
        let { skuList, isStoreArea, isWarrantyCard, systemType } = rootItem;
        let children = [];
        if (skuList && skuList.length > 0) {
          skuList.forEach((item, mIndex) => {
            let { tyreList, ...others } = item;
            if (tyreList && tyreList.length > 0) {
              tyreList.forEach((tyre, i) => {
                children.push({
                  isStoreArea,
                  isWarrantyCard,
                  systemType,
                  ...tyre,
                  ...others,
                  __index__: outIndex + "_" + mIndex + "_" + i + "_key" // 添加索引，嵌套表格用
                });
              });
            }
          });
        }
        return {
          children,
          ...rootItem
        };
      });
      return { list: res, total };
    },
    async editCustomerLevel({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: editCustomerLevel,
        variables: data
      });
    },
    async deleteCustomerLevel({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: deleteCustomerLevel,
        variables: data
      });
    },
    async updateStoreRecordStatus(
      { commit, state, rootState }: any,
      data?: any
    ) {
      await rootState.gql.mutate({
        mutation: updateStoreRecordStatus,
        variables: data
      });
    },
    async querySupplierInventory({ commit, rootState }, params) {
      let { data } = await rootState.gql.query({
        query: querySupplierInventory,
        variables: params
      });
      const result = {
        list: resRest(data),
        total: data.api.pageInfo.totalCount || 0
      };
      // commit("easyMutate", { path: "dataList", data: result.list });
      return result;
    },
    async querySupplierCount({ commit, rootState }, params) {
      let { data } = await rootState.gql.query({
        query: querySupplierCount,
        variables: params
      });
      const result = {
        list: resRest(data),
        total: data.api.pageInfo.totalCount || 0
      };
      return result;
    },
    async exportSupplierCount({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: exportSupplierCount,
        variables: data
      });
    },
    async getPCRAttr({ commit, state, rootState }: any, data?: any) {
      const {
        data: { api }
      } = await rootState.gql.query({
        query: getPCRAttr,
        variables: data
      });
      // 扁平率 _flatten
      // 花纹 _pattern
      // 轮毂直径 _hubDiameter
      // 断面宽 _sectionWidth
      const attrCodes = api.map(({ attrCode, dataList }) => ({
        label: attrCode && attrCode.replace(/[^0-9A-Za-z]+/g, ""),
        value: dataList
      }));
      // attrCodes.forEach(({ label, value }) => {
      //   commit("easyMutate", { path: `${label}List`, data: value });
      // });
      return attrCodes || {};
    },
    // 查询K2查询权限
    async queryStoreViewInventoryStatus({ rootState }, params = {}) {
      const data = await http(
        "/k1/inventory/queryStoreViewInventoryStatus",
        params
      );
      return data ? data.data : {};
    },

    // 关闭或者打开K2查询权限
    async updateStoreViewInventoryStatus({ rootState }, params = {}) {
      const data = await http(
        "/k1/inventory/updateStoreViewInventoryStatus",
        params
      );
      return data ? data.data : {};
    },
    async queryLastFiveYearsWithMerge(
      { commit, state, rootState }: any,
      params?: any
    ) {
      const { data = {} } = await rootState.gql.query({
        query: queryLastFiveYearsWithMerge,
        variables: params
      });
      console.log(data, "00090data");
      return data.data || [];
    },
    async getOrgSupplierCountQuantity(
      { commit, state, rootState }: any,
      params?: any
    ) {
      const { data } = await rootState.gql.query({
        query: getOrgSupplierCountQuantity,
        variables: params
      });
      console.log(data, "getOrgSupplierCountQuantity");
      return data.data || "";
    },

    // K1电商出库”、“K1调拨入库” 获取列表接口
    async querySupplierScanRecordCommerce({ rootState }, params = {}) {
      const data = await http(
        "/k1/scan/querySupplierScanRecordCommerce",
        params
      );
      return data
        ? data.data || { list: [], total: 0 }
        : { list: [], total: 0 };
    },

    // K1扫码记录--K1调拨入库+K1电商出库tab的导出接口
    async commerceSupplierScanRecordDetailExport({ rootState }, params = {}) {
      const data = await http(
        "/k1/scan/commerceSupplierScanRecordDetailExport",
        params
      );
      return data ? data.data : "";
    }
  },
  mutations: {
    easyMutate
  }
};
